import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "snackbar-container" }
const _hoisted_2 = { class: "snackbar-container__message" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "snackbar-container__item",
        key: index
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(message.message), 1),
        _createElementVNode("button", {
          class: "snackbar-container__close",
          type: "button",
          onClick: ($event: any) => (_ctx.dismiss(index))
        }, "×", 8, _hoisted_3)
      ]))
    }), 128))
  ]))
}